import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService } from '../../config';
import { CustomHttp } from '../../http';
import { toHTTPParam } from './date-utils.service';
import { IntervaloSemana } from './intervalo-semana';

@Injectable({
    providedIn: 'root'
})
export class DateUtilsHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/utils/data`;
    }

    /** Obtem o intervalo entre o primeiro e último dia da semana com base na data base informada */
    getIntervaloSemana(dataBase: Date, retornarDiasSemana: boolean): Observable<IntervaloSemana> {
        // Params
        let params = new HttpParams();
        // Data Base
        if (dataBase) {
            params = params.append('dataBase', toHTTPParam(dataBase));
        }
        // Retornar dias da semana
        params = params.append('retornarDiasSemana', retornarDiasSemana.toString());

        return this.customHttp.get<IntervaloSemana>(`${this.pathApi}/intervalosemana`, {params});
    }

    /** Obtem o intervalo entre o primeiro e último dia da próxima semana com base na data base informada */
    getIntervaloProximaSemana(dataBase: Date, retornarDiasSemana: boolean): Observable<IntervaloSemana> {
        // Params
        let params = new HttpParams();
        // Data Base
        dataBase = new Date(dataBase);
        if (dataBase) {
            params = params.append('dataBase', toHTTPParam(dataBase));
        }
        // Retornar dias da semana
        params = params.append('retornarDiasSemana', retornarDiasSemana.toString());

        return this.customHttp.get<IntervaloSemana>(`${this.pathApi}/intervalosemana/proxima`, {params});
    }

    /** Obtem o intervalo entre o primeiro e último dia da semana anterior com base na data base informada */
    getIntervaloSemanaAnterior(dataBase: Date, retornarDiasSemana: boolean): Observable<IntervaloSemana> {
        // Params
        let params = new HttpParams();
        // Data Base
        dataBase = new Date(dataBase);
        if (dataBase) {
            params = params.append('dataBase', toHTTPParam(dataBase));
        }
        // Retornar dias da semana
        params = params.append('retornarDiasSemana', retornarDiasSemana.toString());

        return this.customHttp.get(`${this.pathApi}/intervalosemana/anterior`, {params});
    }

    /** Verifica se é o mês atual */
    isMesAtual(mes: number, ano: number): Observable<boolean> {
        // Params
        let params = new HttpParams();
        // Mês
        if (mes) {
            params = params.append('mes', mes.toString());
        }
        // Ano
        if (ano) {
            params = params.append('ano', ano.toString());
        }

        return this.customHttp.get<boolean>(`${this.pathApi}/ismesatual`, {params});
    }
}
